<app-modal-container
  [formGroup]="teamMemberForm"
  [title]="this.teamMemberForm.value.uuid ? 'Edit company member' : 'New company member'"
  [buttons]="modalButtons"
  [applyActivated]="teamMemberForm.valid"
  (applyButtonClicked)="confirm()"
  (closeButtonClicked)="close(false)"
  (dismissButtonClicked)="close(false)"
  (lowerLeftButtonClicked)="deleteButtonClicked()">
  <div class="vertical-container-simple column-gap-1">
    <div class="row-container row-gap-1 grid-3rows" *ngVar="teamMemberForm.controls as form">
      <!--Name-->
      <app-input
        data-qa="employee-name"
        formControlName="name"
        [required]="true"
        [title]="'First name'"
        [placeholder]="'First name'"
        [inputID]="'name'"
        [additionalClass]="form.name.errors ? 'error' : ''">
      </app-input>
      <!--Workplace-->
      <app-input
        data-qa="employee-workplace"
        formControlName="companyName"
        [title]="'Workplace'"
        [placeholder]="'Workplace'"
        [inputID]="'workplace'"
        [additionalClass]="'disabled'">
      </app-input>
      <!--Email-->
      <app-input
        data-qa="employee-email"
        formControlName="mail"
        [required]="true"
        [title]="'Email'"
        [placeholder]="'Email'"
        [inputID]="'email'"
        [additionalClass]="form?.mail?.errors ? 'error' : ''"
        (inputChange)="teamMemberForm.patchValue({ mail: $event.toLowerCase()})">
      </app-input>
      <!--Last name-->
      <app-input
        data-qa="employee-surname"
        formControlName="family"
        [title]="'Last name'"
        [placeholder]="'Last name'"
        [inputID]="'lastName'">
      </app-input>
      <!--Position-->
      <app-input-autocomplete
        data-qa="employee-position"
        formControlName="position"
        [title]="'Position'"
        [data]="positions"
        [selectedObject]="this.member?.position ?? null"
        [inputID]="'position'">
      </app-input-autocomplete>
      <!--Phone-->
      <app-input
        data-qa="employee-phone"
        formControlName="phone"
        [title]="'Phone'"
        [placeholder]="'Phone'"
        [inputID]="'phone'">
      </app-input>
    </div>
  </div>
</app-modal-container>

<app-modal-dialog
  *ngIf="showDeleteEmployeeModal"
  [header]="'Delete member'"
  [useStandardList]="false"
  [mainText]="[this.member.name + ' will be deleted']"
  [addAdditionalText]="true"
  (isConfirmed)="deleteTeamMember($event)">
</app-modal-dialog>
